import React from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';

class ImageExpand extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    if (this.props.imageUrl) {
      return (
        <>
          <div
            className="image-expand"
            style={{
              pointerEvents:
                'auto' /* this allow make click here in 'preview' mode */,
            }}
          >
            <div className="image-expand-img-wrapper">
              <img
                alt="Question or answer"
                src={this.props.imageUrl}
                onClick={(e) => {
                  e.stopPropagation();
                  this.toggle();
                }}
              />
            </div>
            <Button
              color="link"
              className="expand-image"
              onClick={(e) => {
                e.stopPropagation();
                this.toggle();
              }}
            >
              <i className="icon-zoom" />
            </Button>
          </div>
          <Modal
            isOpen={this.state.modal}
            toggle={this.toggle}
            modalClassName="expanded-image-modal"
          >
            <ModalBody>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={this.toggle}
              >
                <span aria-hidden="true">×</span>
              </button>
              <img
                alt="Expanded question or answer"
                src={this.props.imageUrl}
              />
            </ModalBody>
          </Modal>
        </>
      );
    }
    return <></>;
  }
}

export default ImageExpand;
